import { get } from './axios.js'

let api = '/api'

export const getRecommendList = query => get(api + '/getRecommendRelationList?' + (query || ''))
export const getTopicList = query => get(api + '/getSubjectList?' + (query || ''))
